import { ConfirmationModal, useModal } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { toast } from '@webapp/components/Notification'
import { makeSelectUser } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { useMutateCancelCardAdmin } from '@webapp/modules/spending-cards/features/cancel-card-admin/models/useMutateCancelCardAdmin'
import messages from './messages'

export const useCancelCardAdminPresenter = () => {
  const user = useSelector(makeSelectUser())
  const modal = useModal()
  const intl = useProcurifyIntl()

  const { cancel } = useMutateCancelCardAdmin()

  const showCancelCardModal = async (
    externalId: string,
    cardholderUserId: number,
    isCardBalanceNegative: boolean = false,
    onCardCanceled: () => void = () => null
  ) => {
    const userIsCardholder = cardholderUserId === user.id

    let modalContent = userIsCardholder
      ? intl.formatMessage(messages.modalUserIsCardholderContent)
      : intl.formatMessage(messages.modalDefaultContent)

    if (isCardBalanceNegative) {
      modalContent = userIsCardholder
        ? intl.formatMessage(
            messages.modalUserIsCardholderNegativeBalanceContent
          )
        : intl.formatMessage(messages.modalNegativeBalanceContent)
    }

    await modal.showModal(ConfirmationModal, {
      open: true,
      icon: 'attention',
      type: 'danger',
      header: intl.formatMessage(messages.modalTitle),
      content: modalContent,
      confirmButtonText: intl.formatMessage(messages.modalConfirmButton),
      handleDismiss: () => modal.hideModal(),
      onConfirm: async () => {
        try {
          await cancel({ externalId })

          toast.success({
            title: intl.formatMessage(messages.successToastMessage),
          })
          onCardCanceled()
          modal.hideModal()
        } catch (error) {
          toast.error({
            title: intl.formatMessage(messages.errorToastMessage),
          })
        }
      },
    })
  }

  return {
    commands: {
      showCancelCardModal,
    },
  }
}
